import i18n from '@dms/i18n';

import {Category} from '../types/Category';

export const TEMPLATE_CATEGORIES: Record<string, Category> = {
  sales: {
    id: 'sales',
    label: i18n.t('general.labels.sell'),
    icon: 'action/assessment',
    colorStripe: 'blue',
    position: 1,
  },
  afterSales: {
    id: 'afterSales',
    label: i18n.t('general.labels.service'),
    icon: 'action/build',
    colorStripe: 'purple',
    position: 3,
  },
  accounting: {
    id: 'accounting',
    label: i18n.t('module.accounting.title'),
    icon: 'custom/invoice',
    position: 2,
    colorStripe: 'orange',
  },
  caraudit: {
    id: 'caraudit',
    label: i18n.t('module.CarAudit.title'),
    icon: 'maps/directions_car',
    position: 4,
    colorStripe: 'teal',
  },
  other: {
    id: 'other',
    label: i18n.t('entity.vehicle.labels.otherLabel'),
    icon: 'AV/replay',
    position: 5,
    colorStripe: 'neutral',
  },
};
